import { useEffect, useCallback, useState, useRef } from 'react';
import { Popup } from '@progress/kendo-react-popup';
import { KWELLO_ICON, KwelloSvgIcon } from '../../components/icon/KwelloSvgIcon';
import ClickableDiv from '../clickableDiv/ClickableDiv';
import { ProjectSelectorContent } from './ProjectSelectorContent';
import { useModuleProjectContext } from 'common/contexts/useModuleProjectContext';
import { useDispatch } from 'react-redux';
import { resetDatasetQuestion } from 'common/store/slices/dataset.slice';

export function ProjectSelector() {
  const dispatch = useDispatch();
  const [isExpanded, setIsExpanded] = useState(false);
  const { activeModule, activeProject } = useModuleProjectContext();

  const onProjectChange = () => {
    dispatch(resetDatasetQuestion());
    setIsExpanded(false);
  };

  const outsideClickhandler = useCallback(
    (e: MouseEvent) => {
      const allowedClasses = [
        'project-display-name',
        'project-select-checkbox',
        'project-select-checkbox-empty',
        'active-project',
        'project-selector-button-outline',
      ];
      if (
        e.target instanceof HTMLElement &&
        !allowedClasses.includes(e.target.classList.toString())
      ) {
        setIsExpanded(false);
      }
    },
    [setIsExpanded]
  );

  useEffect(() => {
    document.body.addEventListener('click', outsideClickhandler);
    return () => {
      document.body.removeEventListener('click', outsideClickhandler);
    };
  }, [outsideClickhandler]);

  const anchor = useRef<HTMLDivElement | null>(null);

  if (activeModule?.projects.length === 1) {
    return (
      <div className="single-project-label">
        <span className="active-project">{activeProject?.projectDisplayName}</span>
      </div>
    );
  }

  return (
    <>
      <div ref={anchor}>
        <ClickableDiv
          className="project-selector-button-outline"
          onClick={() => {
            setIsExpanded(!isExpanded);
          }}
        >
          <span className="active-project">{activeProject?.projectDisplayName}</span>
          <KwelloSvgIcon icon={KWELLO_ICON.CHEVRON_DOWN_ICON} />
        </ClickableDiv>
      </div>
      {isExpanded && (
        <Popup anchor={anchor.current} show={isExpanded}>
          <ProjectSelectorContent onChange={onProjectChange} />
        </Popup>
      )}
    </>
  );
}
